/**
 * 아이디 찾기
 */
import React, { Component } from 'react';
import { Form, Button } from 'react-bootstrap';
import $ from 'jquery';
import { url, udfInlineLoading, udfNoneLoading, AlertModal, openAlert } from '../common/common';
import loader from '../imgs/ajax-loader.gif';
import logoBi from '../logo-bi.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';

class SearchIdCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      validated: false,
      authEmailLabelNm: '등록한 이메일 주소',
      partKey: null,
    }
  }

  componentDidMount = () => {
    const that = this;

    $.ajax({
      url: url + '/uat/chkIndex.do',
      type: 'GET',
      dataType: "jsonp",
      data: {
        isMobile: 'Y',
      },
      success: function (data) {
        that.setState({ partKey: data.partKey });
      },
      error: function (jqXHR, status, error) {
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const that = this;

    if (form.checkValidity()) {
      udfInlineLoading();

      var postData = {
        isMobile: 'Y',
        AUTH_EMAIL: $("#AUTH_EMAIL").val(),
        "egovframework.double.submit.preventer.parameter.name": that.state.partKey,
      };

      $.ajax({
        type: "POST",
        dataType: "jsonp",
        url: url + '/html/searchId.do',
        data: postData,
        success: function (data) {
          udfNoneLoading();
          if (data.success) {
            openAlert(that, "이메일 발송되었습니다.");
          } else {
            openAlert(that, "일치하는 이메일 주소가 없습니다.");
          }
          that.setState({ partKey: data.partKey });
        },
        error: function () {
          openAlert(that, "요청 실패!");
          udfNoneLoading();
        }
      });
    }

    this.setState({ validated: true });
  }

  render() {
    const { validated } = this.state;

    return (
      <div className="container-fluid App-header">
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        <div onClick={() => { this.props.history.go(-1) }} className="btn-back"><FontAwesomeIcon icon={faArrowCircleLeft} /></div>
        <div className="wrap-loading d-none">
          <img src={loader} alt="로딩 이미지" />
        </div>
        <Form
          className="loginForm col"
          noValidate
          validated={validated}
          onSubmit={e => this.handleSubmit(e)}
          style={{ maxWidth: '340px', textAlign: 'center' }}
        >
          <img src={logoBi} alt="스쿨라이프" style={{ width: "90%", marginBottom: '1rem' }} />
          <Form.Group controlId="AUTH_EMAIL" className="has-feedback has-feedback-left">
            <Form.Control type="email" className="login form-control-lg" placeholder={this.state.authEmailLabelNm} aria-describedby="AUTH_EMAIL" required />
            <FontAwesomeIcon icon={faAt} className="form-control-feedback login" />
            <Form.Control.Feedback type="invalid">
              {this.state.authEmailLabelNm}를 입력해주세요.
            </Form.Control.Feedback>
          </Form.Group>
          <p>이메일로 아이디 찾기 결과를 보내드립니다.</p>
          <p>본인이 직접 스쿨라이프에 로그인 하여 이메일을 등록한 사실이 있어야 이용 가능합니다.</p>
          <p>만약 등록한 사실이 없다면 해당 기능을 지원받지 못합니다. 이런 경우에는 학교 담임선생님 또는 생활지도담당선생님께 문의하여 아이디 확인 / 비밀번호 초기화를 요청해 주시면 됩니다.</p>
          <Button type="submit" className="btn btn-lg btn-height btn-school-life col">아이디 찾기</Button>
        </Form>
      </div>
    );
  }
}

export default SearchIdCmp;